import {createContext, useEffect, useState} from "react";
import {Loading} from "../Component/Loading/Loading";
import Notify from "../Notify/Notify";
import LoginService from "../../Modules/Auth/LoginService";


export const UserContext = createContext({
    reloadUser: () => {
    },
    currentUser: null
});

export const UserLoad = ({children}) => {

    const reloadUser = (user) => {
        setCurrentUser({
            currentUser: user,
            reloadUser: reloadUser
        })
    };

    const [currentUser, setCurrentUser] = useState({
        currentUser: null,
        reloadUser: reloadUser
    });

    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const loginService = new LoginService();
        loginService.getMe().then((x) => {

            setCurrentUser({
                currentUser: x.user,
                reloadUser: reloadUser
            });

            setIsLoading(false);
        }).catch(() => {
            Notify.warning('Não autorizado')
            setIsLoading(false);
        });

    }, []);


    return <UserContext.Provider value={currentUser}>
        <Loading isLoading={isLoading}>
            {!isLoading && children}
        </Loading>
    </UserContext.Provider>
}

